/**
 * LIRE UN FICHIER POUR LE VERSER — écrit une fois, employé par deux écrans.
 *
 * ⚠️ CES TROIS FONCTIONS VIVAIENT DANS `documents.tsx`. Le téléversement dans
 * une affaire en a besoin mot pour mot ; les recopier aurait donné deux
 * lectures de fichier qui divergent au premier correctif — et `base64De` en
 * porte un qui ne se voit pas : `String.fromCharCode(...vue)` sur un fichier
 * de plusieurs mégaoctets dépasse la taille maximale de la pile d'arguments.
 * Une copie naïve « plus simple » rendrait donc le téléversement impossible
 * au-delà de quelques centaines de kilooctets, et seulement chez l'utilisateur.
 */

export function octets(n: number): string {
  if (n < 1024) return `${n} o`;
  if (n < 1048576) return `${(n / 1024).toFixed(1)} Ko`;
  return `${(n / 1048576).toFixed(1)} Mo`;
}

/**
 * ⚠️ `crypto.subtle` N'EXISTE QU'EN CONTEXTE SÉCURISÉ. En son absence on
 * n'envoie PAS d'empreinte plutôt que d'en envoyer une fausse : le serveur
 * calcule la sienne de toute façon, c'est le contrôle du TRANSPORT qu'on perd.
 */
export async function empreinteLocale(octetsFichier: ArrayBuffer): Promise<string | undefined> {
  if (!globalThis.crypto?.subtle) return undefined;
  const condensat = await crypto.subtle.digest('SHA-256', octetsFichier);
  return [...new Uint8Array(condensat)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export function base64De(octetsFichier: ArrayBuffer): string {
  const vue = new Uint8Array(octetsFichier);
  let binaire = '';
  // Par tranches : `String.fromCharCode(...vue)` sur un fichier de plusieurs
  // méga-octets dépasse la taille maximale de la pile d'arguments.
  const PAS = 32768;
  for (let i = 0; i < vue.length; i += PAS) binaire += String.fromCharCode(...vue.subarray(i, i + PAS));
  return btoa(binaire);
}
